export enum DialogResult {
  Success = 'success',
  Error = 'error',
  Cancel = 'cancel',
}
